<template>
  <div class="header">
    <div class="header-container" :class="{ 'fixed': headerFixed }">
      <div class="container">
        <a class="logo" href="/" alt="派链"></a>
        <div class="menu">
          <a class="browser" href="/">浏览器</a>
          <a href="/business">商务</a>
        </div>
      </div>
    </div>
    <div class="header-placeholder"></div>
  </div>
</template>
<script>
export default {
  name: "page-header",
  data() {
    return {
      headerFixed: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 获取滚动位置
      const scrollPosition =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.headerFixed = 10 < scrollPosition;
    }
  },
};
</script>
<style scoped>
.header-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 99;
}

.header-container.fixed {
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0px 4px 15px 0px rgba(38, 62, 79, 0.2);
}

.header .container {
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
}

.header .logo {
  flex-shrink: 0;
  margin-right: 10px;
}

.header .menu a {
  line-height: 68px;
  color: #FFF;
  font-size: 16px;
  padding: 0 48px;
}

.header .menu a.browser {
  position: relative;
}

.header .menu a.browser:after {
  content: "";
  width: 1px;
  height: 20px;
  background: #FFF;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

@media (max-width: 1199px) {
  .header .container {
    height: 40px;
  }

  .logo {
    width: 87px;
    height: 36px;
  }

  .header .menu a {
    line-height: 40px;
    font-size: 12px;
    padding: 0 15px;
  }

  .header .menu a.browser:after {
    height: 12px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/page-header.vue